(ns hypnos.sleeplab.tile.table.communication
  "The communications table."
  (:require [hypnos.i18n :refer [tr]]
            [hypnos.time :as t]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- comp-by-communicated-at
  [c1 c2]
  (let [dt1 (:communication/communicated-at c1)
        dt2 (:communication/communicated-at c2)]
    (t/before? dt2 dt1)))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Tables

(defn table
  "Table containing the patient communications."
  []
  (let [patient        (rf/subscribe [:sleeplab/patient])
        communications (get-in @patient [:communication/_recipient] [])]
    (cond
      (empty? communications)
      [:div.card-content
       [:section.section
        [:div.content.has-text-grey.has-text-centered
         [:p [:span.icon.is-large [:i.mdi.mdi-message-text.mdi-48px]]]
         [:p (tr :ui.label/no-communications)]]]]
      :else
      [:div.table-container
       [:table.table.is-fullwidth.is-striped.is-hoverable.is-sortable.is-fullwidth
        [:thead
         [:tr
          [:th]
          [:th (tr :ui.label/communicated-at)]
          [:th (tr :ui.label/type)]
          [:th (tr :ui.label/channel)]
          [:th (tr :ui.label/to)]
          ;; [:th (tr :ui.label/status)]
          [:th]]]
        [:tbody
         (doall
          (for [communication (sort (comp comp-by-communicated-at) communications)]
            ^{:key (:communication/id communication)}
            [:tr
             [:td]
             [:td (t/format-date t/MMM-d-YYYY-HH-MM-SS-TZ (t/to-default-time-zone (:communication/communicated-at communication)))]
             [:td (tr :ui/communication-type (:communication/type communication))]
             [:td (tr :ui/communication-channel (:communication/channel communication)) ]
             [:td (:communication/to communication)]
             ;; [:td (tr :ui.label/communication-channel (:communication/status communication))]
             [:td]]))]]])))
